/**
 * @typedef TRight
 * @property {boolean} create
 * @property {boolean} delete
 * @property {boolean} modify
 * @property {boolean} read
 */

export default class Droit {
	/**
	 * @param {any} [droit]
	 */
	constructor(droit = null) {
		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = droit?.kid || undefined;

		/** @type {number} */
		this.kright = droit?.kright || 0;

		/**
		 * @type {{
		 *   isa: import('@knitiv/api-client-javascript').KNode | '0' | undefined,
		 *   kid: import('@knitiv/api-client-javascript').KNode | '0' | undefined,
		 *   name: string,
		 *   name_type_kid: import('@knitiv/api-client-javascript').TypeIdV4
		 * }}
		 */
		this.org = {
			isa: droit?.org?.isa || droit?.org_isa || 'K_NODE;SYS_CLASSE',
			kid: droit?.org?.kid || droit?.org_kid || 'K_NODE;KROLE',
			name: droit?.org?.name || droit?.org_name || '',
			name_type_kid: droit?.org?.name_type_kid || 'K_NODE;STRING',
		};

		/**
		 * @type {{
		 *   isa: import('@knitiv/api-client-javascript').KNode | '0' | undefined,
		 *   kid: import('@knitiv/api-client-javascript').KNode | '0' | undefined,
		 *   name: string,
		 *   name_type_kid: import('@knitiv/api-client-javascript').TypeIdV4
		 * }}
		 */
		this.role = {
			isa: droit?.role?.isa || droit?.role_isa,
			kid: droit?.role?.kid || droit?.role_kid || droit?.ref_role,
			name: droit?.role?.name || droit?.role_name || '',
			name_type_kid: droit?.role?.name_type_kid || 'K_NODE;STRING',
		};
	}

	export11() {
		return {
			kid:       this.kid,
			kright:    this.kright,
			ref_role:  this.role?.kid,
			role_name: this.role?.name,
		};
	}

	export() {
		return {
			kid:      this.kid,
			kright:   this.kright,
			org_kid:  this.org?.kid,
			role_kid: this.role?.kid,
		};
	}

	get tright() {
		return {
			create: (this.kright & 4) !== 0,
			delete: (this.kright & 1) !== 0,
			modify: (this.kright & 2) !== 0,
			read:   (this.kright & 8) !== 0,
		};
	}

	/**
	 * @param {TRight} tright
	 */
	set tright(tright) {
		// @ts-ignore
		this.kright = (tright.delete & 1)
			// @ts-ignore
			+ (tright.modify & 2)
			// @ts-ignore
			+ (tright.create & 4)
			// @ts-ignore
			+ (tright.read & 8);
	}
}
